<template>
  <div>
    <Head title="Dashboard" />
    <div class="shadow_box rounded-lg p-6">
      <div class="w-full flex items-center gap-10">
        <div class="px-5 py-10 mb-10 w-full max-w-sm shadow-lg rounded-md">
          <div class="flex items-center justify-between">
            <div class="w-16 h-16 rounded-full bg-primary text-white text-2xl flex items-center justify-center">
              <font-awesome-icon icon="fa-users" />
            </div>

            <p class="font-bold text-6xl text-gray-400">
              {{ patients }}
            </p>
          </div>

          <p class="text-lg font-bold mt-4">
            Quantidade de pacientes
          </p>
        </div>

        <div class="px-5 py-10 mb-10 w-full max-w-sm shadow-lg rounded-md">
          <div class="flex items-center justify-between">
            <div class="w-16 h-16 rounded-full bg-primary text-white text-2xl flex items-center justify-center">
              <font-awesome-icon icon="fa-user-doctor" />
            </div>

            <p class="font-bold text-6xl text-gray-400">
              {{ doctors }}
            </p>
          </div>

          <p class="text-lg font-bold mt-4">
            Quantidade de médicos
          </p>
        </div>
      </div>

      <div class="flex flex-wrap max-w-7xl m-auto my-0">
        <div class="mb-5 lg:mb-10 w-full lg:w-5/12 lg:pr-6">
          <div class="w-full text-center text-xl mb-6">Consultas por especialidade</div>
          <doughnut-chart class="my-6" :chartData="this.chartDoughnutData()" />
        </div>
        <div class="mb-10 w-full lg:w-7/12">
          <div class="w-full text-center text-xl mb-6 font-poppins">Agendamentos</div>
          <progress-chart :totalMonth="totalMonth" :totalDay="totalDay" :totalInProgress="totalInProgress" :totalCompleted="totalCompleted" :totalNotCompleted="totalNotCompleted" :totalReschedule="totalReschedule" />
        </div>
      </div>
      <line-chart class="my-6" :chartData="this.chartLineData()" />
    </div>
  </div>
  <modal-update-photo-profile ref="modalUpdatePhotoProfile" />
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import format from 'date-fns/format';
import LineChart from '@/Shared/Components/LineChart'
import DoughnutChart from '@/Shared/Components/DoughnutChart'
import ProgressChart from '@/Shared/Components/ProgressChart'
import ModalUpdatePhotoProfile from '@/Shared/Modal/ModalUpdatePhotoProfile'

export default {

  props: {
    doctors: 0,
    patients: 0,
    totalDay: 0,
    totalMonth: 0,
    totalInProgress: 0,
    totalCompleted: 0,
    totalNotCompleted: 0,
    totalReschedule: 0,
    totalBySpecialty: Object,
    totalByMonth: Object,

  },
  components: {
    Head,
    format,
    LineChart,
    DoughnutChart,
    ProgressChart,
    ModalUpdatePhotoProfile,
  },
  layout: Layout,
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  watch: {

  },
  computed: {

  },
  mounted() {
    if(this.user.professional){
      if(!this.user.photo) {
        this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
      }
    }

  },
  data() {
    return {

    }
  },
  methods: {
    chartDoughnutData() {
      let labels = [];
      let colors = [];
      let values = [];
      for(let index in this.totalBySpecialty) {
        let specialty = this.totalBySpecialty[index];
        labels.push(specialty.name);
        colors.push(specialty.color);
        values.push(specialty.appointments);
      }
      return {
        labels: labels,
        datasets: [
          {
            backgroundColor: colors,
            data: values
          }
        ]
      }
    },
    chartLineData() {
      var style = getComputedStyle(document.body);
      var colorPrimary = style.getPropertyValue('--color-primary');
      var colorSecondary = style.getPropertyValue('--color-secondary');
      let labels = [];
      let values = [];
      for(let index in this.totalByMonth) {
        let v = this.totalByMonth[index];
        let month = index.split('-').reverse().join('/');
        labels.push(month);
        values.push(v);
      }
      return {
        labels: labels,
        datasets: [
          {
            label: 'Agendamentos por mês',
            backgroundColor: colorPrimary,
            borderColor: colorSecondary,
            data: values
          }
        ]
      }
    },
    openModalUpdatePhotoProfile() {
      this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
    },
  },
}
</script>
